module.exports = __webpack_public_path__ + "static/media/editing.0b3f79fb.wav";